import { ILogt } from "../models/logT";
import LogTSearchResponse from "../types/logTSearchResponse";
import { LogtActions, LogtActionTypes } from '../types/logTTypes';

export interface LogtState {
    logts: ILogt[];
    totalPages: number;
    totalCount: number;
    loading: boolean;
    error: string | null;
    page: number;
    limit: number;
}

const initialState: LogtState = {
    logts: [],
    totalPages: 0,
    totalCount: 0,
    loading: true,
    error: null,
    page: 1,
    limit: 10,
};

const logTReducer = (state = initialState, action: LogtActions): LogtState => {
    switch (action.type) {
        case LogtActionTypes.SEARCH_LOGT:
        case LogtActionTypes.SEARCH_LOGT_ALL:
            return {
                ...state,
                loading: true,
                error: null
            };
        case LogtActionTypes.SEARCH_LOGT_SUCCESS:
            return {
                ...state,
                logts: (action.payload as LogTSearchResponse).logs, 
                totalPages: (action.payload as LogTSearchResponse).totalPages,
                totalCount: (action.payload as LogTSearchResponse).totalCount ?? 0,
                loading: false,
                error: null
            };
        case LogtActionTypes.SEARCH_LOGT_ALL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case LogtActionTypes.SEARCH_LOGT_ERROR:
        case LogtActionTypes.SEARCH_LOGT_ALL_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case LogtActionTypes.CLEAR_LOGT:
            return {
                ...initialState,
                loading: false,
            };
        default:
            return state;
    }
};

export default logTReducer;
